<template>
    <div class="avatar-upload-cls">
        <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
            <h3>Drop files to upload</h3>
        </div>
        <div class="avatar-upload">
            <label for="avatar">
                <img :src="file"
                     class="avatar-logo"/>
                Drop files anywhere to upload
            </label>
            <file-upload
                extensions="gif,jpg,jpeg,png,webp"
                accept="image/png,image/gif,image/jpeg,image/webp"
                name="avatar"
                class="btn btn-primary"
                post-action="/upload/post"
                :drop="true"
                v-model="files"
                @input-filter="inputFilter"
                @input-file="inputFile"
                ref="upload">
                UPLOAD {{contentText}}
            </file-upload>
        </div>
    </div>
</template>


<script>
    import FileUpload from 'vue-upload-component'

    export default {
        name: "avatar-upload",
        components: {
            FileUpload,
        },
        props: {
            contentText: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                files: [],
                logo: null,
                file: '',
                gravatar : require('../../assets/gravatar.png')
            }
        },
        computed: {},
        methods: {
            alert(message) {
                alert(message)
            },

            inputFile(newFile, oldFile, prevent) {
            },

            inputFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
                        this.alert('Your choice is not a picture');
                        return prevent()
                    }
                }

                if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
                    newFile.url = '';
                    let URL = window.URL || window.webkitURL;
                    if (URL && URL.createObjectURL) {
                        newFile.url = URL.createObjectURL(newFile.file);
                        this.file = newFile.url;

                        var reader = new FileReader();
                        reader.readAsDataURL(newFile.file);
                        let self = this;
                        reader.onload = function () {
                            self.logo = reader.result;
                        };
                        reader.onerror = function (error) {
                            self.logo = '';
                        };
                    }
                }
            },
            getAvatarData() {
                return this.logo;
            },
            setAvatarData(logo) {
                this.logo = logo;
                if (this.logo != null && this.logo !== '') {
                    this.file = this.logo;
                }
                else {
                    this.file = this.gravatar;
                }
            }

        }
    }
</script>


<style>


    .avatar-upload {
        display: flex;
        justify-content: center;
    }

    .avatar-upload-cls .drop-active {
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        position: fixed;
        z-index: 9999;
        opacity: .6;
        text-align: center;
        background: #000;
    }

    .avatar-upload-cls .drop-active h3 {
        margin: -.5em 0 0;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        font-size: 40px;
        color: #fff;
        padding: 0;
    }

    .avatar-logo {
        width: 50px;
        height: 50px;
        border-radius: 100px;
        margin-left: 100px;
    }

    .file-uploads-drop {
        font-family: 'Digital-Serial-Bold';
        background-color: rgb(117, 32, 250);
        border: none;
        color: white;
        line-height: 40px;
        font-size: 16px;
        max-height: 40px;
        height: 40px;
        width: 200px;
        font-weight: bold;
        padding: 0px 0px;
        margin-left: 10px;
    }

    .btn-primary:hover {
        transform: scale(1.1);
        color: white;
        background-color: rgb(117, 32, 250);
        border-color: transparent;
    }
</style>



// WEBPACK FOOTER //
// src/components/avatar-upload/AvatarUpload.vue